<div *ngIf="contents;else normal" class="tooltip-avatar rounded w-150">
    {{text}}
    <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<ng-template #normal>
    <div class="tooltip-wrapper rounded w-150">
        {{text}}
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
</ng-template>